/* 🤖 this file was generated by script */
export const wsolidiconPower02 = {
  name: 'power_02',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m1 6a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0zM8.8 9.6a1 1 0 1 0-1.6-1.2 6 6 0 1 0 9.6 0 1 1 0 0 0-1.6 1.2 4 4 0 1 1-6.4 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
